"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _reactUseIdHook = require("react-use-id-hook");
var _CompletedContext = require("../CompletedContext");
require("./TaskPassageReveal.css");
var _excluded = ["content", "onMouseInteract", "dropdownPlacement", "currentHover"],
  _excluded2 = ["children", "contents", "dropdownPlacement"];
var PassageRevealContext = /*#__PURE__*/_react.default.createContext({});
var PassageRevealHotspot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PassageRevealHotspot, _Component);
  var _super = (0, _createSuper2.default)(PassageRevealHotspot);
  function PassageRevealHotspot(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PassageRevealHotspot);
    _this = _super.call(this, props);
    _this.state = {
      selected: false
    };
    _this.onMouseIn = _this.onMouseIn.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseOut = _this.onMouseOut.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyboard = _this.onKeyboard.bind((0, _assertThisInitialized2.default)(_this));
    _this.buttonRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(PassageRevealHotspot, [{
    key: "onMouseIn",
    value: function onMouseIn() {
      if (!this.state.selected) {
        this.setState({
          selected: true
        });
      }
      this.props.onMouseInteract(true);
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      if (this.state.selected) {
        this.setState({
          selected: false
        });
      }
      this.props.onMouseInteract(false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.currentHover !== this.props.index && this.state.selected) {
        this.setState({
          selected: false
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.onKeyboard);
      document.documentElement.addEventListener('click', this.onMouseOut);
      if (this.buttonRef.current) {
        this.buttonRef.current.scrollIntoView({
          block: 'nearest'
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onKeyboard);
      document.documentElement.removeEventListener('click', this.onMouseOut);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      if (this.state.selected && e.key === "Escape") {
        this.setState({
          selected: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$placement;
      var selected = this.state.selected; //|| this.props.lastSelected
      var _this$props = this.props,
        content = _this$props.content,
        onMouseInteract = _this$props.onMouseInteract,
        dropdownPlacement = _this$props.dropdownPlacement,
        currentHover = _this$props.currentHover,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var describedby;
      if (this.props.content && selected) {
        describedby = "task-callouts-tooltip-" + this.props.index;
      }
      return /*#__PURE__*/_react.default.createElement("mark", Object.assign({}, rest, {
        className: "callout " + this.props.className,
        ref: this.buttonRef,
        id: "task-callouts-tab-" + this.props.index,
        tabIndex: "0",
        style: this.props.style,
        key: this.props.index,
        "aria-describedby": describedby,
        "aria-label": this.props.label,
        onMouseEnter: this.onMouseIn,
        onMouseOver: this.onMouseIn,
        onPointerDown: this.onMouseIn,
        onGotPointerCapture: this.onMouseIn,
        onPointerOver: this.onMouseIn,
        onPointerEnter: this.onMouseIn,
        onTouchStart: this.onMouseIn,
        onFocus: this.onMouseIn,
        onBlur: this.onMouseOut,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }), this.props.content && selected && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        tooltipId: "task-callouts-tooltip-" + this.props.index,
        placement: (_this$props$placement = this.props.placement) !== null && _this$props$placement !== void 0 ? _this$props$placement : "bottom",
        content: /*#__PURE__*/_react.default.createElement("div", {
          className: "tooltip-inner-inner",
          tabIndex: "0",
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();
          }
        }, this.props.content),
        target: this.buttonRef.current
      }), this.props.children);
    }
  }]);
  return PassageRevealHotspot;
}(_react.Component);
function Passage(_ref) {
  var children = _ref.children,
    contents = _ref.contents,
    dropdownPlacement = _ref.dropdownPlacement,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  var value = _react.default.useContext(PassageRevealContext);
  var id = (0, _reactUseIdHook.useId)();
  _react.default.useEffect(function () {
    if ((value === null || value === void 0 ? void 0 : value.registeredIds) === undefined) {
      return;
    }
    value.registeredIds[id] = true;
    return function () {
      delete value.registeredIds[id];
    };
  });
  if ((value === null || value === void 0 ? void 0 : value.registeredIds) === undefined) {
    return /*#__PURE__*/_react.default.createElement("mark", {
      style: {
        backgroundColor: props.color
      }
    }, children);
  }
  var index = Object.keys(value.registeredIds).indexOf(id);
  var revealed = value.revealed;
  var currentHover = value.currentHover;
  if (revealed) {
    return /*#__PURE__*/_react.default.createElement(PassageRevealHotspot, Object.assign({}, props, {
      key: id + "hotspot",
      className: revealed ? "revealed" : "",
      children: children,
      onMouseInteract: function onMouseInteract() {
        value.onHover(index);
      },
      currentHover: currentHover,
      index: index,
      content: contents,
      style: revealed ? {
        backgroundColor: props.color
      } : {},
      dropdownPlacement: dropdownPlacement,
      exitOnHover: props.exitOnHover
    }));
  }
  return children;
}
var TaskPassageReveal = exports.default = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(TaskPassageReveal, _Component2);
  var _super2 = (0, _createSuper2.default)(TaskPassageReveal);
  function TaskPassageReveal(props) {
    var _this2;
    (0, _classCallCheck2.default)(this, TaskPassageReveal);
    _this2 = _super2.call(this, props);
    _this2.state = props.state || {};
    if (!_this2.state.initialized) {
      _this2.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this2.state.completed = false;
      _this2.state.revealed = _this2.props.noReveal;
      _this2.state.hovered = [];
      _this2.state.registeredIds = {};
      _this2.state.currentHover = undefined;
    }

    // This gets set every time because `this` can change!
    _this2.state.onHover = function (index) {
      var hovered = _this2.state.hovered.slice();
      hovered[index] = true;
      if (!_this2.props.noReveal) return;
      for (var member in _this2.state.registeredIds) {
        var i = Object.keys(_this2.state.registeredIds).indexOf(member);
        if (_this2.state.registeredIds[member] && !hovered[i]) {
          _this2.setState({
            hovered: hovered,
            currentHover: index,
            completed: false
          });
          return;
        }
      }
      _this2.setState({
        hovered: hovered,
        currentHover: index,
        completed: true
      });
    };
    return _this2;
  }
  (0, _createClass2.default)(TaskPassageReveal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-passage-reveal"
      }, /*#__PURE__*/_react.default.createElement(PassageRevealContext.Provider, {
        value: this.state
      }, this.props.children), !this.props.noReveal && /*#__PURE__*/_react.default.createElement(_Button.default, {
        style: {
          display: "block",
          marginLeft: "auto"
        },
        onClick: function onClick() {
          _this4.setState({
            revealed: !_this4.state.revealed,
            completed: true
          });
        }
      }, this.state.revealed ? "Hide Marks" : "Reveal Marks"));
    }
  }]);
  return TaskPassageReveal;
}(_react.Component);
TaskPassageReveal.contextType = _CompletedContext.CompletedContext;
TaskPassageReveal.Passage = Passage;